import styled from 'styled-components';

export const ToolbarRowStyled = styled.div`
  padding: 16px 24px;
  border-bottom: 1px solid ${p => p.theme.colors.border};
  background: ${p => p.theme.colors.white};
  .ant-select { width: 100%; }
`;

export const ViewToggleStyled = styled.div`
  display: inline-flex;
  align-items: center;
  gap: 10px;
  background: ${p => p.theme.colors.white};
  border: 1px solid ${p => p.theme.colors.border};
  border-radius: 20px;
  padding: 6px 16px;
`;

export const ViewLabelStyled = styled.span`
  color: ${p => p.$active ? p.theme.colors.primary : p.theme.colors.textLight};
  font-weight: ${p => p.$active ? 600 : 400};
  white-space: nowrap;
`;

export const BodyStyled = styled.div`
  flex: 1;
  min-height: 0;
  overflow: hidden;
  display: flex;
  flex-direction: column;
`;

export const SummaryWrapperStyled = styled.div`
  height: calc(100vh - 400px);
  overflow-y: auto;
  overflow-x: auto;
`;

export const CenterStyled = styled.div`
  display: flex;
  justify-content: center;
`;

export const CompareBtnWrapperStyled = styled.div`
  display: flex;
  justify-content: center;
  .ant-btn {
    white-space: nowrap;
    width: 100%;
  }
`;

export const SpinCenterStyled = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  flex: 1;
  padding: 48px;
`;

export const SummaryListStyled = styled.ul`
  margin: 0;
  padding-left: 18px;
  text-align: left;
`;
